import { render, staticRenderFns } from "./LnbigQrCode.vue?vue&type=template&id=07b6bc35&scoped=true&"
import script from "./LnbigQrCode.vue?vue&type=script&lang=js&"
export * from "./LnbigQrCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6bc35",
  null
  
)

export default component.exports